import {
  Box,
  Flex,
  VStack,
  Input,
  Select,
  Text,
} from '@chakra-ui/react';
import { countries, softwareLanguages } from './constants/data';

const DashboardUserDetails = ({ firstName, lastName, email, password, country, language, setFirstName, setLastName, setCountry, setLanguage }) => (
    <VStack spacing={4} align="stretch">
      {/* Name Fields */}
      <Flex gap={4}>
        <Box flex={1}>
          <Input
            size="sm"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            placeholder="Enter first name" />
        </Box>
        <Box flex={1}>
          <Input
            size="sm"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            placeholder="Enter last name" />
        </Box>
      </Flex>

      {/* Email Field */}
      <Flex align="center" gap={4}>
        <Box flex={1}>
          <Input
            size="sm"
            value={email}
            placeholder="Enter email"
            type="email"
            isDisabled
            bg="gray.100"
          />
        </Box>
        <Text fontSize="sm" color="gray.500">Verified</Text>
      </Flex>

      {/* Password Field */}
      <Box>
        <Input
          size="sm"
          value={password}
          placeholder="Password"
          type="password"
          isDisabled
          bg="gray.100"
        />
      </Box>

      {/* Country Field */}
      <Box>
        <Select
          size="sm"
          value={country}
          onChange={(e) => setCountry(e.target.value)}
          placeholder="Select country"
        >
          {countries.map((country) => (
            <option key={country.id} value={country.id}>
              {country.name}
            </option>
          ))}
        </Select>
      </Box>

      {/* Language Field */}
      <Box>
        <Select
          size="sm"
          value={language}
          onChange={(e) => setLanguage(e.target.value)}
          placeholder="Select language"
        >
          {softwareLanguages.map((lang) => (
            <option key={lang.short} value={lang.short}>
              {lang.language}
            </option>
          ))}
        </Select>
      </Box>
    </VStack>
);

export default DashboardUserDetails;